import React from 'react'
import styled from 'styled-components'

import Link from 'components/Link'
import ErrorMessage from 'components/ErrorMessage'
import Button from 'components/Button'
import { routes } from 'constants/routes'
import WorkspaceSidebarLayout from '../../components/WorkspaceSidebarLayout'

import { ReactComponent as Logo } from 'icons/workspace-64.svg'

const StyledErrorMessage = styled(ErrorMessage)`
  flex: 1 0 auto;
  align-self: center;
  max-width: 480px;
  padding: 16px;
  height: auto;
`

interface NoWorkspaceViewProps {
  title?: string
  additionalMessage?: React.ReactNode
}

export const NoWorkspaceView: React.FC<NoWorkspaceViewProps> = () => (
  <WorkspaceSidebarLayout title="No Workspaces">
    <StyledErrorMessage
      title="Create your first Workspace"
      icon={<Logo />}
      extra={
        <Link
          to={{
            pathname: routes.WORKSPACE_CREATE.create({}),
            state: { fromNoWorkspaces: true },
          }}>
          <Button variant="primary">Create Workspace</Button>
        </Link>
      }>
      Saved documents will display here. Kick off your <b>30-day free trial</b>{' '}
      by creating your first Workspace!
    </StyledErrorMessage>
  </WorkspaceSidebarLayout>
)
